import React from 'react';
import { CardBody, CardHeader } from 'reactstrap';

const CountryTransactions = ({ data, loading }) => {
  if (loading || !data?.transactions?.location) {
    return <React.Fragment />;
  }

  const maxTransactions = Math.max(...data.transactions.location.map(item => item.item_count));

  return (
    <div className="flex flex-col rounded-md border animate-in fade-in-50 mt-2">
      <CardHeader className="bg-slate-50 mb-2 text-purple-900 relative">
        <div className="float-right text-sm pt-0.5 z-20 relative -mt-0.5">
          <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-sm text-xs font-medium bg-purple-100 text-purple-800">Last 30 Days</span>
        </div>
        <h2 className="text-lg text-purple-900 z-20 relative mt-0.5">
          Transactions <span className="font-bold">By Location</span>
        </h2>
      </CardHeader>

      <CardBody className="card-inner pt-1 pb-4 px-4">
        <table className="w-full">
          <thead>
            <tr>
              <th/>
              <th className="text-left text-sm font-bold pb-2 pl-1">Location</th>
              <th className="text-right text-sm font-bold pb-2">Count</th>
              <th className="text-right text-sm font-bold pb-2 pr-2">Processed</th>
            </tr>
          </thead>
          <tbody>
            {data.transactions.location.map((item, index) => (
              <tr
                key={index}
                className="relative transition-colors"
              >
                <td className="absolute h-[90%] w-full top-[5%] left-0">
                  <div
                    className="h-full bg-violet-100 rounded-r-xl"
                    style={{
                      width: `${(item.item_count / maxTransactions) * 100}%`,
                    }}
                  />
                </td>
                <td className="py-2 relative">
                  <div className="relative flex items-center gap-2">
                    <span className="text-slate-600 pl-1 font-normal"><strong>{item.area.split(',')[0]}</strong> ({item.area.split(', ')[1]})</span>
                  </div>
                </td>
                <td className="text-right text-slate-500 relative z-10">{item.item_count}</td>
                <td className="text-right text-slate-500 relative z-10 pr-2">{new Intl.NumberFormat('en-GB', {
                  style: 'currency',
                  currency: 'GBP',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(
                  item.total_value,
                )}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardBody>
    </div>
  );
};

export default CountryTransactions;